import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let ourVacanciesSwiperWr = document.querySelectorAll('.our-vacancies-swiper-wr');

ourVacanciesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      slidesPerView: 1,
      spaceBetween: 0,
      threshold: 10,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl,
        prevEl,
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      effect: 'creative',
      creativeEffect: {
        limitProgress: 3,
        // progressMultiplier: 1,
        next: {
          translate: ['calc(100% + 20px)', 0, 0],
          opacity: 1,
          scale: 1,
        },
        prev: {
          opacity: 0,
          translate: [0, '40%', 0],
        },
      },
      breakpoints: {
      // 768: {
        // slidesPerView: 1,
      // },
      // 1280: {
        // slidesPerView: 1,
        // creativeEffect: {
        //   limitProgress: 3,
        //   next: {
        //     translate: [0, -80, 0],
        //     opacity: 1,
        //     scale: 1,
        //   },
        //   prev: {
        //     opacity: 0,
        //     translate: [0, '50%', 0],
        //   },
        // },
      // },
      },
    });

    swiperObserver(swiper);
  }
});